import IMoon, { IconProps } from 'react-icomoon'

const iconSet = require('./selection.json')

export type IconNames =
  | 'activity'
  | 'alarm'
  | 'alert'
  | 'all'
  | 'aging-in-place'
  | 'apps'
  | 'arcade'
  | 'archive'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'audio-status-active'
  | 'audio-status'
  | 'award'
  | 'bell'
  | 'book'
  | 'box'
  | 'briefcase'
  | 'bulb'
  | 'business'
  | 'calculator'
  | 'calendar'
  | 'camera-plus'
  | 'capture'
  | 'chat'
  | 'check'
  | 'checkbox-active'
  | 'checkbox'
  | 'checket'
  | 'checks'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'class'
  | 'click'
  | 'clipboard-check'
  | 'clipboard'
  | 'clock'
  | 'close'
  | 'communication'
  | 'community'
  | 'compass'
  | 'cooking'
  | 'copy'
  | 'creativity'
  | 'desktop'
  | 'devices'
  | 'dialog'
  | 'dice'
  | 'directions'
  | 'download'
  | 'drop-down'
  | 'drop-up'
  | 'duration'
  | 'ear'
  | 'edit'
  | 'encore'
  | 'enter'
  | 'explore'
  | 'exposure'
  | 'eye-off'
  | 'eye'
  | 'exercise'
  | 'face-id'
  | 'facebook-empty'
  | 'facebook'
  | 'file-text'
  | 'file'
  | 'filters'
  | 'finance'
  | 'financial-planning'
  | 'fingerprint'
  | 'flag'
  | 'flame'
  | 'flip-camera'
  | 'focus'
  | 'folder'
  | 'folders'
  | 'for-you'
  | 'friends'
  | 'gamepad'
  | 'ghost'
  | 'gift'
  | 'glass-full'
  | 'globe'
  | 'government'
  | 'grid-dots'
  | 'guide'
  | 'heart'
  | 'help'
  | 'hiring-and-jobs'
  | 'history'
  | 'home'
  | 'info'
  | 'instagram'
  | 'introduction-view'
  | 'key'
  | 'language'
  | 'layout-horizontal'
  | 'layout-list'
  | 'layout-vertical'
  | 'leaf'
  | 'lightning'
  | 'link'
  | 'linkedIn'
  | 'list-checks'
  | 'list'
  | 'live'
  | 'loader-1'
  | 'loader'
  | 'location'
  | 'lock-full'
  | 'lock-open-full'
  | 'lock-open'
  | 'lock'
  | 'login'
  | 'logout'
  | 'mail'
  | 'map-pin'
  | 'maximize'
  | 'media'
  | 'menu'
  | 'mic-off'
  | 'mic'
  | 'minimize'
  | 'mobile'
  | 'more-actions'
  | 'move-btm'
  | 'move-top'
  | 'music'
  | 'newbie'
  | 'news'
  | 'note'
  | 'notebook'
  | 'notes'
  | 'on-demand'
  | 'paperclip'
  | 'pause'
  | 'payment'
  | 'pen'
  | 'people-add'
  | 'performing-arts'
  | 'phone-call'
  | 'photo'
  | 'photography'
  | 'pinned'
  | 'plans'
  | 'play-full'
  | 'play'
  | 'plus'
  | 'pop-Out'
  | 'popout'
  | 'popout2'
  | 'presentation'
  | 'puzzle'
  | 'question'
  | 'radio-off'
  | 'radio-on'
  | 'react'
  | 'reset'
  | 'resize-maximise'
  | 'resize-minimise'
  | 'retry'
  | 'room'
  | 'rotate'
  | 'sad'
  | 'school'
  | 'screen-share-off'
  | 'search'
  | 'selector'
  | 'send'
  | 'series'
  | 'settings'
  | 'shapes'
  | 'share-screen'
  | 'share'
  | 'shield-check'
  | 'smile'
  | 'senior'
  | 'socialising'
  | 'speakerphone'
  | 'star-empty'
  | 'star-full'
  | 'stop'
  | 'swap'
  | 'switch--camera'
  | 'switch--camera1'
  | 'tablet'
  | 'tag'
  | 'technology'
  | 'trash'
  | 'travel'
  | 'trophy'
  | 'twitter-full'
  | 'twitter'
  | 'upload'
  | 'user-check'
  | 'user'
  | 'users'
  | 'video-off'
  | 'video'
  | 'view-columns'
  | 'view-gallery'
  | 'view-one-to-one-off'
  | 'view-one-to-one'
  | 'view-speaker'
  | 'view-stage'
  | 'volume-off'
  | 'volume'
  | 'wellness'
  | 'window'
  | 'youtube-full'
  | 'youtube'
  | 'on-demand'

interface IcoMoonProps extends IconProps {
  icon: IconNames
}

const IcoMoon: React.FC<IcoMoonProps> = (props) => <IMoon iconSet={iconSet} {...props} />

export default IcoMoon
